import type { ExternalSignatureReportView } from '@safetyhub/shared';
import api, { type ApiResponse } from './api';

export interface ContactSignatureTokenInfo {
  id: string;
  signerName: string;
  signerPosition: string | null;
  signerDepartment: string | null;
  tokenExpiresAt: string | null;
  sentAt: string | null;
  /** approval/delete-approval과 동일 스키마 (Phase 3-a: 공통 shell 전환) */
  report: ExternalSignatureReportView;
}

/**
 * 토큰으로 담당자 서명 요청 조회 (@Public)
 */
export async function getContactSignatureByToken(
  token: string,
): Promise<ContactSignatureTokenInfo> {
  const response = await api.get<ApiResponse<ContactSignatureTokenInfo>>(
    `/contact-signatures/by-token/${token}`,
    { skipAuth: true } as any,
  );
  return response.data.data!;
}

export interface SubmitContactSignatureInput {
  signatureData: string;
  signatureMethod?: 'DRAWN' | 'TYPED' | 'DIGITAL';
  /**
   * 외부 서명자 자가 수정 플래그. true일 때 서버가 아래 3개 필드를 snapshot/원본에 반영합니다.
   * 이름/직책/부서만 수정 가능 (연락처 도용 방지를 위해 phone/email은 서버 DTO에서 거부).
   */
  updateSigner?: boolean;
  signerName?: string;
  signerPosition?: string;
  signerDepartment?: string;
}

export interface SubmitContactSignatureResult {
  id: string;
  signedAt: string;
  signerUpdated?: boolean;
}

/**
 * 토큰으로 담당자 서명 제출 (@Public)
 */
export async function submitContactSignatureByToken(
  token: string,
  data: SubmitContactSignatureInput,
): Promise<SubmitContactSignatureResult> {
  const response = await api.post<ApiResponse<SubmitContactSignatureResult>>(
    `/contact-signatures/by-token/${token}`,
    data,
    { skipAuth: true } as any,
  );
  return response.data.data!;
}
